import { render, staticRenderFns } from "./DownlineRepDisplaySetting.vue?vue&type=template&id=5672af2b&"
import script from "./DownlineRepDisplaySetting.vue?vue&type=script&lang=js&"
export * from "./DownlineRepDisplaySetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports